export default "__VITE_ASSET__CT0Dzvp$__"